import { useState } from 'react';
import axios from 'axios';
import './semantic.css';
import TabMachines from './Views/TabMachines';
import TabTour from './Views/TabTour';
import TabTech from './Views/TabTech';
import TabSettings from './Views/TabSettings';
import TabLogin from './Views/TabLogin';


function App() {
  const [sessionKey, setSessionKey] = useState(
    JSON.parse(localStorage.getItem('sessionKey')) || null
  );
  const [sessionUser, setSessionUser] = useState(
    JSON.parse(localStorage.getItem('sessionUser')) || null
  );
  const [userType, setUserType] = useState(
    JSON.parse(localStorage.getItem('userType')) || 'tour'
  );

  const [userOptions, setUserOptions] = useState(
    JSON.parse(localStorage.getItem('userOptions')) || {packlist: 'category', refill: 'planned'}
  );
  const [visibleTab, setVisibleTab] = useState(
    userType=='tech' ? 'tech' : 'route'
  );
  const [tourData, setTourData] = useState(
    JSON.parse(localStorage.getItem('tourData')) || []
  );
  const [techData, setTechData] = useState(
    JSON.parse(localStorage.getItem('techData')) || []
  );
  const [serviceQueue, setServiceQueue] = useState(
    JSON.parse(localStorage.getItem('serviceQueue')) || []
  );
  const [unsentItems, setUnsentItems] = useState(
    serviceQueue.length
  );
  axios.defaults.headers.common['SessionKey'] = sessionKey;

  function handleTab(tabName) {
    setVisibleTab(tabName);
  }

  const getTourData = () => {
    axios.post(process.env.REACT_APP_CUSTOM_URL + 'getTours')
      .then(response => {
        localStorage.setItem('tourData', JSON.stringify(response.data.tours));
        setTourData(response.data.tours);
      });
  }

  const getTechData=()=>{
    axios.post(process.env.REACT_APP_CUSTOM_URL + 'getTech')
      .then(response => {
        localStorage.setItem('techData', JSON.stringify(response.data.tech));
        setTechData(response.data.tech);
      });
  }

  const serviceQueueAdd = async (addedService) => {
    let newServiceQueue = [
      ...serviceQueue,
      addedService
    ];

    var online = true;
    var counter = 0;
    while (newServiceQueue.length > 0 && online && counter < 50) {
      let currentItem = newServiceQueue[0];
      await axios.post(process.env.REACT_APP_CUSTOM_URL + 'serviceUpdate', { service: currentItem })
        .then(response => {
          newServiceQueue.shift();
        }).catch(error => {
          online = false;
        });
      counter++;
    }
    setServiceQueue(newServiceQueue);
    setUnsentItems(newServiceQueue.length);
    localStorage.setItem('serviceQueue', JSON.stringify(newServiceQueue));
  }

  const serviceQueueSend = async () => {
    let newServiceQueue = serviceQueue;
    if(newServiceQueue.length==0)return;
    var online = true;
    var counter = 0;
    while (newServiceQueue.length > 0 && online && counter < 50) {
      let currentItem = newServiceQueue[0];
      await axios.post(process.env.REACT_APP_CUSTOM_URL + 'serviceUpdate', { service: currentItem })
        .then(response => {
          newServiceQueue.shift();
        }).catch(error => {
          online = false;
        });
      counter++;
    }
    setServiceQueue(newServiceQueue);
    setUnsentItems(newServiceQueue.length);
    localStorage.setItem('serviceQueue', JSON.stringify(newServiceQueue));
  }

  let content;
  if (sessionKey == null) {
    content = <TabLogin sessionKey={sessionKey} onSetSessionKey={setSessionKey} onSetSessionUser={setSessionUser} onSetUserType={setUserType} onSetUserOptions={setUserOptions} onGetTourData={getTourData} onGetTechData={getTechData}/>
  }
  else {
    let Expiry = new Date(JSON.parse(localStorage.getItem('sessionExpiry')));
    let ControlDate = new Date();
    ControlDate.setHours(ControlDate.getHours() + 2);
    if (Expiry < ControlDate) {
      axios.post(process.env.REACT_APP_BASE_URL + 'auth/validate')
        .then(response => {
          let Expiry = String(response.data.ExpiryTimestamp);
          localStorage.setItem('sessionExpiry', JSON.stringify(Expiry));
        }).catch(function (error) {
          localStorage.removeItem('sessionKey');
          localStorage.removeItem('tourData');
          localStorage.removeItem('sessionUser');
          setSessionKey(null);
          setSessionUser(null);
        });
    }
    switch (visibleTab) {
      case 'machines':
        content = <TabMachines setServiceQueue={serviceQueueAdd} userOptions={userOptions} />
        break;
      case 'route':
        content = <TabTour tours={tourData} onGetTourData={getTourData} onSetTourData={setTourData} setServiceQueue={serviceQueueAdd} getTourData={getTourData} userOptions={userOptions} />
        break;
      case 'tech':
        content = <TabTech tech={techData} onGetTechData={getTechData} onSetTechData={setTechData} setServiceQueue={serviceQueueAdd} getTechData={getTechData} userOptions={userOptions} />
        break;
      default:
        content = <TabSettings sessionKey={sessionKey} serviceQueueSend={serviceQueueSend} unsentItems={unsentItems} onSetSessionKey={setSessionKey} sessionUser={sessionUser} onSetSessionUser={setSessionUser} userOptions={userOptions} />
        break;
    }

  }

  return (
    <div>
      <div className="ui main app-content">
        {content}
      </div>
      {sessionKey == null ? '' :
        <div className="ui inverted bottom fixed equal width menu">
          {
          userType=='tech' ? 
          <a className={"item " + (visibleTab == 'tech' ? 'active' : '')} onClick={e=>handleTab('tech')} style={{paddingBottom:1.5+'em',paddingTop:1.5+'em'}}><i className="screwdriver icon"></i> Technik</a>
          :
          ''
          }
          <a className={"item " + (visibleTab == 'route' ? 'active' : '')} onClick={e=>handleTab('route')} style={{paddingBottom:1.5+'em',paddingTop:1.5+'em'}}><i className="route icon"></i> Tour</a>
          <a className={"item " + (visibleTab == 'machines' ? 'active' : '')} onClick={e=>handleTab('machines')} style={{paddingBottom:1.5+'em',paddingTop:1.5+'em'}} ><i className="tools icon"></i> Automat</a>
          <a className={"item " + (visibleTab == 'settings' ? 'active' : '')} onClick={e=>handleTab('settings')} style={{paddingBottom:1.5+'em',paddingTop:1.5+'em'}} ><i className="icon user cog icon"></i> User {(unsentItems>0 ? '('+unsentItems+')' : '')}</a>
        </div>
      }
    </div>
  );
}

export default App;
